// hydracms.js - the tiny script every site loads. For visitors it applies published edits (waiting for hydration so React/Vue are not disturbed);
// when an editor signs in (?hydracms, Ctrl+Shift+E, a [data-hydracms-login] link, or a saved session) it loads the full editor.
import { applyAuto, applySeo } from './auto';

(function () {
  const self = document.currentScript as HTMLScriptElement | null ?? document.querySelector<HTMLScriptElement>('script[data-site][src*="hydracms"]');
  const site = self?.dataset.site;
  const base = (self?.dataset.api ?? (self ? new URL(self.src).origin : '')).replace(/\/$/, '');
  if (!site || !base || (window as any).__hcmsViewer) return;
  (window as any).__hcmsViewer = true;
  if (/^\/cms\/?$/.test(location.pathname)) { location.replace('/?hydracms'); return; } // website.com/cms is the login address

  let editorLoading = false;
  const loadEditor = () => {
    if (editorLoading || (window as any).__hcmsBooted) return; editorLoading = true;
    const s = document.createElement('script');
    s.src = `${base}/hydracms-editor.js`; s.setAttribute('data-site', site); s.setAttribute('data-api', base);
    document.head.append(s);
  };
  const wantsEditor = () => {
    try { if (localStorage.getItem(`hydracms:token:${site}`)) return true; } catch {}
    return /[?&]hydracms\b/.test(location.search) || location.hash === '#hydracms' || document.cookie.includes('hcms_t=');
  };
  addEventListener('keydown', (e) => { if (e.ctrlKey && e.shiftKey && (e.key === 'E' || e.key === 'e')) { e.preventDefault(); loadEditor(); } });
  document.addEventListener('click', (e) => {
    const a = (e.target as Element | null)?.closest?.('[data-hydracms-login]');
    if (a) { e.preventDefault(); loadEditor(); }
  });
  // Older edge snippets inject this file with data-api expecting the editor itself: keep them working.
  if (wantsEditor() || self?.hasAttribute('data-api')) { loadEditor(); return; } // the editor applies drafts itself

  let fields: Record<string, { t: string; v: any }> = {};
  const run = () => { try { applyAuto(fields); applySeo(fields); } catch (e) { console.warn('[HydraCMS]', e); } };
  fetch(`${base}/v1/sites/${site}/content`).then((r) => r.json()).then((d) => {
    fields = d.fields ?? {};
    if (!Object.keys(fields).length) return;
    const go = () => {
      setTimeout(() => {
        run();
        // frameworks re-render after hydration or on navigation: re-apply to anything new
        let t = 0;
        new MutationObserver(() => { clearTimeout(t); t = window.setTimeout(run, 200); }).observe(document.body, { childList: true, subtree: true });
      }, 400);
    };
    if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
  }).catch(() => {});
})();
